import { render, staticRenderFns } from "./SceneAdd.vue?vue&type=template&id=bdcd8396&scoped=true&"
import script from "./SceneAdd.vue?vue&type=script&lang=js&"
export * from "./SceneAdd.vue?vue&type=script&lang=js&"
import style0 from "./SceneAdd.vue?vue&type=style&index=0&id=bdcd8396&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcd8396",
  null
  
)

export default component.exports